import { addClass, removeClass } from "./utils";

export const tabs = (container) => {
  const tabs = Array.from(container.querySelectorAll(".tab"));
  const panes = Array.from(container.querySelectorAll(".tab-pane"));

  tabs.forEach((tab, i) => {
    tab.addEventListener("click", (_e) => {
      activate(tabs, i);
      activate(panes, i);
    });
  });

  // default open
  activate(tabs, 0);
  activate(panes, 0);
};

const activate = (els, index) => {
  els.forEach((el, i) => {
    if (index === i) {
      addClass(el, "active");
    } else {
      removeClass(el, "active");
    }
  });
};
